import type { AreaDict } from '../messages'

// Área "Recorrentes": RecurringPage, RecurringFormDialog, IncludeRecurringDialog.
// pt-BR = textos atuais do app.
const recurring: AreaDict = {
  'pt-BR': {
    'rec.title': 'Recorrentes',
    'rec.subtitle': 'Por mês: ✓ já incluída nas transações · ⏱ disponível para incluir.',
    'rec.newRecurring': 'Nova recorrente',
    'rec.includeRecurring': 'Incluir recorrentes ({count})',
    'rec.prevMonth': 'Mês anterior',
    'rec.nextMonth': 'Próximo mês',
    'rec.monthSummary': '{included} incluídas · {available} disponíveis',
    'rec.backToCurrentMonth': 'Voltar ao mês atual',
    'rec.filter.statusAll': 'Todas',
    'rec.filter.notIncluded': '⏱ Não lançadas',
    'rec.filter.included': '✓ Já incluídas',
    'rec.filter.searchPlaceholder': 'Buscar descrição, categoria ou conta…',
    'rec.col.status': 'Status',
    'rec.col.description': 'Descrição',
    'rec.col.frequency': 'Frequência',
    'rec.col.account': 'Conta',
    'rec.col.category': 'Categoria',
    'rec.col.dueDate': 'Vencimento',
    'rec.col.amount': 'Valor',
    'rec.status.included': 'Incluída',
    'rec.status.available': 'Disponível',
    'rec.status.includedChip': '✓ Incluída',
    'rec.status.availableChip': '⏱ Disponível',
    'rec.noDescription': '(sem descrição)',
    'rec.noEnd': 'sem fim',
    'rec.include': 'Incluir',
    'rec.na': 'N/A',
    'rec.naTitle': 'Não vai acontecer neste mês — tira do orçado sem lançar gasto',
    'rec.undoNa': 'Marcado como N/A — clique para desfazer',
    'rec.dueOn': 'Vence {date}',
    'rec.freq.weekly': 'Semanal',
    'rec.freq.monthly': 'Mensal',
    'rec.freq.yearly': 'Anual',
    'rec.freq.quarterly': 'Trimestral',
    'rec.freq.semiannual': 'Semestral',
    'rec.freq.withInterval': '{base} ({n}x)',
    'rec.freq.adverb.weekly': 'semanais',
    'rec.freq.adverb.monthly': 'mensais',
    'rec.freq.adverb.quarterly': 'trimestrais',
    'rec.freq.adverb.semiannual': 'semestrais',
    'rec.freq.adverb.yearly': 'anuais',
    'rec.empty.title': 'Nenhuma recorrente cai em {month}.',
    'rec.empty.description': 'Crie uma recorrente para automatizar lançamentos que se repetem.',
    'rec.confirm.deleteTitle': 'Excluir recorrente?',
    'rec.confirm.deleteDescription':
      'Apaga apenas as ocorrências pendentes desta recorrente. As já pagas ficam no histórico.',
    'rec.toast.deleted': 'Recorrente excluída',
    'rec.toast.deleteError': 'Erro ao excluir',
    'rec.toast.includedPending': 'Recorrente incluída (pendente)',
    'rec.toast.includeError': 'Erro ao incluir',
    'rec.toast.markedNA': 'Marcado como não aplicável neste mês',
    'rec.toast.markError': 'Erro ao marcar',
    'rec.includeDialog.title': 'Incluir recorrente',
    'rec.includeDialog.titleMonth': 'Incluir recorrentes — {month}',
    'rec.includeDialog.description': 'Recorrentes deste mês ainda não incluídas. Marque as que quer lançar.',
    'rec.includeDialog.empty': 'Nenhuma recorrente disponível para incluir neste mês.',
    'rec.includeDialog.selectAll': 'Selecionar todas ({count})',
    'rec.includeDialog.searchPlaceholder': 'Buscar por descrição ou conta…',
    'rec.includeDialog.noResults': 'Nenhuma recorrente encontrada.',
    'rec.includeDialog.close': 'Fechar',
    'rec.includeDialog.including': 'Incluindo…',
    'rec.includeDialog.includeCount': 'Incluir ({count})',
    'rec.includeDialog.addedN': '{count} recorrente(s) incluída(s)',
    'rec.form.title.new': 'Nova recorrente',
    'rec.form.title.edit': 'Editar recorrente',
    'rec.form.tab.general': 'Geral',
    'rec.form.tab.recurrence': 'Recorrência',
    'rec.form.kind.expense': 'Despesa',
    'rec.form.kind.income': 'Receita',
    'rec.form.description': 'Descrição',
    'rec.form.descriptionPlaceholder': 'Ex.: Aluguel',
    'rec.form.amount': 'Valor',
    'rec.form.currency': 'Moeda',
    'rec.form.account': 'Conta',
    'rec.form.accountPlaceholder': 'Selecione a conta',
    'rec.form.accountSearch': 'Buscar conta…',
    'rec.form.category': 'Categoria',
    'rec.form.categoryNone': 'Sem categoria',
    'rec.form.categorySearch': 'Buscar categoria…',
    'rec.form.frequency': 'Frequência',
    'rec.form.start': 'Início',
    'rec.form.startFixed': 'Início (fixo)',
    'rec.form.daysOfWeek': 'Dias da semana',
    'rec.form.daysHintNone': 'Sem seleção: cai 1x por semana, no dia do início.',
    'rec.form.daysHint': 'Cai {count}x por semana: {days}.',
    'rec.form.mode.indefinite': 'Sem fim',
    'rec.form.mode.until': 'Tem fim',
    'rec.form.mode.installments': 'Parcelado',
    'rec.form.endDate': 'Data de fim',
    'rec.form.installmentsCount': 'Número de parcelas',
    'rec.form.amountBasisLabel': 'O valor acima é…',
    'rec.form.amountBasis.each': 'De cada parcela',
    'rec.form.amountBasis.total': 'Total (dividir)',
    'rec.form.totalAdjust': '(total {total} — ajuste 1 parcela)',
    'rec.weekday.sun': 'Dom',
    'rec.weekday.mon': 'Seg',
    'rec.weekday.tue': 'Ter',
    'rec.weekday.wed': 'Qua',
    'rec.weekday.thu': 'Qui',
    'rec.weekday.fri': 'Sex',
    'rec.weekday.sat': 'Sáb',
    'rec.form.toast.updated': 'Recorrente atualizada — pendentes ajustadas',
    'rec.form.toast.createdInstallments': 'Recorrente criada: {count} parcelas',
    'rec.form.toast.createdIndefinite': 'Recorrente criada (sem fim)',
    'rec.form.toast.saveError': 'Erro ao salvar',
    'rec.form.err.account': 'Selecione a conta',
    'rec.form.err.amountInvalid': 'Valor inválido',
    'rec.form.err.amountPositive': 'Valor deve ser maior que zero',
    'rec.form.err.startDate': 'Informe a data de início',
    'rec.form.err.endDate': 'Informe a data de fim',
  },
  en: {
    'rec.title': 'Recurring',
    'rec.subtitle': 'By month: ✓ already added to transactions · ⏱ available to add.',
    'rec.newRecurring': 'New recurring',
    'rec.includeRecurring': 'Add recurring ({count})',
    'rec.prevMonth': 'Previous month',
    'rec.nextMonth': 'Next month',
    'rec.monthSummary': '{included} added · {available} available',
    'rec.backToCurrentMonth': 'Back to current month',
    'rec.filter.statusAll': 'All',
    'rec.filter.notIncluded': '⏱ Not added',
    'rec.filter.included': '✓ Already added',
    'rec.filter.searchPlaceholder': 'Search description, category or account…',
    'rec.col.status': 'Status',
    'rec.col.description': 'Description',
    'rec.col.frequency': 'Frequency',
    'rec.col.account': 'Account',
    'rec.col.category': 'Category',
    'rec.col.dueDate': 'Due date',
    'rec.col.amount': 'Amount',
    'rec.status.included': 'Added',
    'rec.status.available': 'Available',
    'rec.status.includedChip': '✓ Added',
    'rec.status.availableChip': '⏱ Available',
    'rec.noDescription': '(no description)',
    'rec.noEnd': 'no end',
    'rec.include': 'Add',
    'rec.na': 'N/A',
    'rec.naTitle': "Won't happen this month — removes it from the budget without recording an expense",
    'rec.undoNa': 'Marked as N/A — click to undo',
    'rec.dueOn': 'Due {date}',
    'rec.freq.weekly': 'Weekly',
    'rec.freq.monthly': 'Monthly',
    'rec.freq.yearly': 'Yearly',
    'rec.freq.quarterly': 'Quarterly',
    'rec.freq.semiannual': 'Semiannual',
    'rec.freq.withInterval': '{base} ({n}x)',
    'rec.freq.adverb.weekly': 'weekly',
    'rec.freq.adverb.monthly': 'monthly',
    'rec.freq.adverb.quarterly': 'quarterly',
    'rec.freq.adverb.semiannual': 'semiannual',
    'rec.freq.adverb.yearly': 'yearly',
    'rec.empty.title': 'No recurring falls in {month}.',
    'rec.empty.description': 'Create a recurring to automate entries that repeat.',
    'rec.confirm.deleteTitle': 'Delete recurring?',
    'rec.confirm.deleteDescription':
      'Deletes only the pending occurrences of this recurring. Those already paid stay in the history.',
    'rec.toast.deleted': 'Recurring deleted',
    'rec.toast.deleteError': 'Error deleting',
    'rec.toast.includedPending': 'Recurring added (pending)',
    'rec.toast.includeError': 'Error adding',
    'rec.toast.markedNA': 'Marked as not applicable this month',
    'rec.toast.markError': 'Error marking',
    'rec.includeDialog.title': 'Add recurring',
    'rec.includeDialog.titleMonth': 'Add recurring — {month}',
    'rec.includeDialog.description': "This month's recurring not added yet. Check the ones you want to record.",
    'rec.includeDialog.empty': 'No recurring available to add this month.',
    'rec.includeDialog.selectAll': 'Select all ({count})',
    'rec.includeDialog.searchPlaceholder': 'Search by description or account…',
    'rec.includeDialog.noResults': 'No recurring found.',
    'rec.includeDialog.close': 'Close',
    'rec.includeDialog.including': 'Adding…',
    'rec.includeDialog.includeCount': 'Add ({count})',
    'rec.includeDialog.addedN': '{count} recurring added',
    'rec.form.title.new': 'New recurring',
    'rec.form.title.edit': 'Edit recurring',
    'rec.form.tab.general': 'General',
    'rec.form.tab.recurrence': 'Recurrence',
    'rec.form.kind.expense': 'Expense',
    'rec.form.kind.income': 'Income',
    'rec.form.description': 'Description',
    'rec.form.descriptionPlaceholder': 'E.g.: Rent',
    'rec.form.amount': 'Amount',
    'rec.form.currency': 'Currency',
    'rec.form.account': 'Account',
    'rec.form.accountPlaceholder': 'Select the account',
    'rec.form.accountSearch': 'Search account…',
    'rec.form.category': 'Category',
    'rec.form.categoryNone': 'No category',
    'rec.form.categorySearch': 'Search category…',
    'rec.form.frequency': 'Frequency',
    'rec.form.start': 'Start',
    'rec.form.startFixed': 'Start (fixed)',
    'rec.form.daysOfWeek': 'Days of the week',
    'rec.form.daysHintNone': 'No selection: falls once a week, on the start day.',
    'rec.form.daysHint': 'Falls {count}x per week: {days}.',
    'rec.form.mode.indefinite': 'No end',
    'rec.form.mode.until': 'Has end date',
    'rec.form.mode.installments': 'Installments',
    'rec.form.endDate': 'End date',
    'rec.form.installmentsCount': 'Number of installments',
    'rec.form.amountBasisLabel': 'The amount above is…',
    'rec.form.amountBasis.each': 'Of each installment',
    'rec.form.amountBasis.total': 'Total (split)',
    'rec.form.totalAdjust': '(total {total} — adjust 1 installment)',
    'rec.weekday.sun': 'Sun',
    'rec.weekday.mon': 'Mon',
    'rec.weekday.tue': 'Tue',
    'rec.weekday.wed': 'Wed',
    'rec.weekday.thu': 'Thu',
    'rec.weekday.fri': 'Fri',
    'rec.weekday.sat': 'Sat',
    'rec.form.toast.updated': 'Recurring updated — pending ones adjusted',
    'rec.form.toast.createdInstallments': 'Recurring created: {count} installments',
    'rec.form.toast.createdIndefinite': 'Recurring created (no end)',
    'rec.form.toast.saveError': 'Error saving',
    'rec.form.err.account': 'Select the account',
    'rec.form.err.amountInvalid': 'Invalid amount',
    'rec.form.err.amountPositive': 'Amount must be greater than zero',
    'rec.form.err.startDate': 'Enter the start date',
    'rec.form.err.endDate': 'Enter the end date',
  },
  es: {
    'rec.title': 'Recurrentes',
    'rec.subtitle': 'Por mes: ✓ ya incluida en las transacciones · ⏱ disponible para incluir.',
    'rec.newRecurring': 'Nueva recurrente',
    'rec.includeRecurring': 'Incluir recurrentes ({count})',
    'rec.prevMonth': 'Mes anterior',
    'rec.nextMonth': 'Mes siguiente',
    'rec.monthSummary': '{included} incluidas · {available} disponibles',
    'rec.backToCurrentMonth': 'Volver al mes actual',
    'rec.filter.statusAll': 'Todas',
    'rec.filter.notIncluded': '⏱ No incluidas',
    'rec.filter.included': '✓ Ya incluidas',
    'rec.filter.searchPlaceholder': 'Buscar descripción, categoría o cuenta…',
    'rec.col.status': 'Estado',
    'rec.col.description': 'Descripción',
    'rec.col.frequency': 'Frecuencia',
    'rec.col.account': 'Cuenta',
    'rec.col.category': 'Categoría',
    'rec.col.dueDate': 'Vencimiento',
    'rec.col.amount': 'Importe',
    'rec.status.included': 'Incluida',
    'rec.status.available': 'Disponible',
    'rec.status.includedChip': '✓ Incluida',
    'rec.status.availableChip': '⏱ Disponible',
    'rec.noDescription': '(sin descripción)',
    'rec.noEnd': 'sin fin',
    'rec.include': 'Incluir',
    'rec.na': 'N/A',
    'rec.naTitle': 'No ocurrirá este mes — lo quita del presupuesto sin registrar un gasto',
    'rec.undoNa': 'Marcado como N/A — clic para deshacer',
    'rec.dueOn': 'Vence {date}',
    'rec.freq.weekly': 'Semanal',
    'rec.freq.monthly': 'Mensual',
    'rec.freq.yearly': 'Anual',
    'rec.freq.quarterly': 'Trimestral',
    'rec.freq.semiannual': 'Semestral',
    'rec.freq.withInterval': '{base} ({n}x)',
    'rec.freq.adverb.weekly': 'semanales',
    'rec.freq.adverb.monthly': 'mensuales',
    'rec.freq.adverb.quarterly': 'trimestrales',
    'rec.freq.adverb.semiannual': 'semestrales',
    'rec.freq.adverb.yearly': 'anuales',
    'rec.empty.title': 'Ninguna recurrente cae en {month}.',
    'rec.empty.description': 'Crea una recurrente para automatizar movimientos que se repiten.',
    'rec.confirm.deleteTitle': '¿Eliminar recurrente?',
    'rec.confirm.deleteDescription':
      'Elimina solo las ocurrencias pendientes de esta recurrente. Las ya pagadas quedan en el historial.',
    'rec.toast.deleted': 'Recurrente eliminada',
    'rec.toast.deleteError': 'Error al eliminar',
    'rec.toast.includedPending': 'Recurrente incluida (pendiente)',
    'rec.toast.includeError': 'Error al incluir',
    'rec.toast.markedNA': 'Marcado como no aplicable este mes',
    'rec.toast.markError': 'Error al marcar',
    'rec.includeDialog.title': 'Incluir recurrente',
    'rec.includeDialog.titleMonth': 'Incluir recurrentes — {month}',
    'rec.includeDialog.description': 'Recurrentes de este mes aún no incluidas. Marca las que quieres registrar.',
    'rec.includeDialog.empty': 'Ninguna recurrente disponible para incluir este mes.',
    'rec.includeDialog.selectAll': 'Seleccionar todas ({count})',
    'rec.includeDialog.searchPlaceholder': 'Buscar por descripción o cuenta…',
    'rec.includeDialog.noResults': 'Ninguna recurrente encontrada.',
    'rec.includeDialog.close': 'Cerrar',
    'rec.includeDialog.including': 'Incluyendo…',
    'rec.includeDialog.includeCount': 'Incluir ({count})',
    'rec.includeDialog.addedN': '{count} recurrente(s) incluida(s)',
    'rec.form.title.new': 'Nueva recurrente',
    'rec.form.title.edit': 'Editar recurrente',
    'rec.form.tab.general': 'General',
    'rec.form.tab.recurrence': 'Recurrencia',
    'rec.form.kind.expense': 'Gasto',
    'rec.form.kind.income': 'Ingreso',
    'rec.form.description': 'Descripción',
    'rec.form.descriptionPlaceholder': 'Ej.: Alquiler',
    'rec.form.amount': 'Importe',
    'rec.form.currency': 'Moneda',
    'rec.form.account': 'Cuenta',
    'rec.form.accountPlaceholder': 'Selecciona la cuenta',
    'rec.form.accountSearch': 'Buscar cuenta…',
    'rec.form.category': 'Categoría',
    'rec.form.categoryNone': 'Sin categoría',
    'rec.form.categorySearch': 'Buscar categoría…',
    'rec.form.frequency': 'Frecuencia',
    'rec.form.start': 'Inicio',
    'rec.form.startFixed': 'Inicio (fijo)',
    'rec.form.daysOfWeek': 'Días de la semana',
    'rec.form.daysHintNone': 'Sin selección: cae 1 vez por semana, el día de inicio.',
    'rec.form.daysHint': 'Cae {count}x por semana: {days}.',
    'rec.form.mode.indefinite': 'Sin fin',
    'rec.form.mode.until': 'Tiene fin',
    'rec.form.mode.installments': 'En cuotas',
    'rec.form.endDate': 'Fecha de fin',
    'rec.form.installmentsCount': 'Número de cuotas',
    'rec.form.amountBasisLabel': 'El importe de arriba es…',
    'rec.form.amountBasis.each': 'De cada cuota',
    'rec.form.amountBasis.total': 'Total (dividir)',
    'rec.form.totalAdjust': '(total {total} — ajusta 1 cuota)',
    'rec.weekday.sun': 'Dom',
    'rec.weekday.mon': 'Lun',
    'rec.weekday.tue': 'Mar',
    'rec.weekday.wed': 'Mié',
    'rec.weekday.thu': 'Jue',
    'rec.weekday.fri': 'Vie',
    'rec.weekday.sat': 'Sáb',
    'rec.form.toast.updated': 'Recurrente actualizada — pendientes ajustadas',
    'rec.form.toast.createdInstallments': 'Recurrente creada: {count} cuotas',
    'rec.form.toast.createdIndefinite': 'Recurrente creada (sin fin)',
    'rec.form.toast.saveError': 'Error al guardar',
    'rec.form.err.account': 'Selecciona la cuenta',
    'rec.form.err.amountInvalid': 'Importe inválido',
    'rec.form.err.amountPositive': 'El importe debe ser mayor que cero',
    'rec.form.err.startDate': 'Indica la fecha de inicio',
    'rec.form.err.endDate': 'Indica la fecha de fin',
  },
}

export default recurring
